/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AdminLabOrder } from './AdminLabOrder';
import type { AdminSlideListBlock } from './AdminSlideListBlock';
import type { AdminSlideListCase } from './AdminSlideListCase';
import type { AdminSlideListSpecimen } from './AdminSlideListSpecimen';
import type { SlideFlag } from './SlideFlag';
import type { SlideStatusChange } from './SlideStatusChange';

export type SlideAdminList = {
    readonly id?: number;
    readonly case?: AdminSlideListCase;
    /**
     * original filename of the slide from the scanner
     */
    name?: string | null;
    readonly created_at?: string;
    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    status?: SlideAdminList.status;
    /**
     * industry name for the extracted 'case id' value. Should match Case.accession
     */
    accession_number?: string | null;
    /**
     * slide number in the provided block
     */
    slide_number?: string | null;
    readonly stain_id?: number;
    readonly specimen?: AdminSlideListSpecimen;
    readonly specimen_id?: number;
    readonly block_obj?: AdminSlideListBlock;
    readonly block_obj_id?: number;
    readonly flags?: Array<SlideFlag>;
    is_rescan?: boolean;
    is_control?: boolean;
    /**
     * selectable status field for QC slide tracking process
     */
    qc_status?: SlideAdminList.qc_status | null;
    /**
     * operational or temporary notes from the quality control team
     */
    qc_notes?: string | null;
    readonly status_changes?: Array<SlideStatusChange>;
    readonly lab_orders?: Array<AdminLabOrder>;
    /**
     * type of slide: brightfield or fluorescence
     */
    slide_type?: SlideAdminList.slide_type;
}

export namespace SlideAdminList {

    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    export enum status {
        RECEIVED_WPL = 'received-wpl',
        RECEIVED_LAB = 'received-lab',
        PENDING = 'pending',
        PRECOMPUTING = 'precomputing',
        UPLOADED = 'uploaded',
        ERROR = 'error',
        MANUAL_MERGE = 'manual-merge',
        MANUAL_REVIEW = 'manual-review',
        SUCCESS = 'success',
        PENDING_AI = 'pending-ai',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        ON_HOLD = 'on-hold',
        PROCESSING = 'processing',
    }

    /**
     * selectable status field for QC slide tracking process
     */
    export enum qc_status {
        CHECKED = 'checked',
        BLURRY = 'blurry',
        CONTACT_LAB = 'contact-lab',
        MISSING_LAB = 'missing-lab',
        MISSING_VIEWER = 'missing-viewer',
        MISLABELED = 'mislabeled',
        UNKNOWN = 'unknown',
    }

    /**
     * type of slide: brightfield or fluorescence
     */
    export enum slide_type {
        BRIGHTFIELD = 'brightfield',
        FLUORESCENCE = 'fluorescence',
    }


}
